import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getDeliveryType, isPudoAvailable} from '../../../selectors/selectors';
import shouldUseAddressTypeButtons from '../../../selectors/shouldUseAddressTypeButtons';
import AddressTypeTabsLazyLoader from './AddressTypeTabs/AddressTypeTabsLazyLoader';
import AddressTypeButtonsLazyLoader from './AddressTypeButtons/AddressTypeButtonsLazyLoader';

export function AddressTypesAsTabsOrButtons(props) {
  return (
    props.isPudoAvailable && (props.useAddressTypeButtons
      ? (
        <AddressTypeButtonsLazyLoader
          isPudoSelected={props.isDeliveryTypePudo}
          step={props.step}
        />
      ) : (
        <AddressTypeTabsLazyLoader
          isPudoSelected={props.isDeliveryTypePudo}
          step={props.step}
          leftAlign
        />
      )
    )
  );
}

AddressTypesAsTabsOrButtons.propTypes = {
  isDeliveryTypePudo: PropTypes.bool.isRequired,
  isPudoAvailable: PropTypes.bool.isRequired,
  useAddressTypeButtons: PropTypes.bool.isRequired,
  step: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  isPudoAvailable: isPudoAvailable(state),
  isDeliveryTypePudo: getDeliveryType(state) === 'pudo',
  useAddressTypeButtons: shouldUseAddressTypeButtons(state),
});

export default connect(mapStateToProps)(AddressTypesAsTabsOrButtons);
